module.exports = __webpack_public_path__ + "static/media/mid.d50842f9.png";